import { Button, TagsInput, Typography } from '@mantine/core';
import { ErrorBoundary } from '@sentry/react';
import { Panel } from 'components/Panel';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { tKeys, useTranslation } from 'locales';
import { useState } from 'react';
import HTML from 'shared/components/HTML/HTML';

import { useUpdateIgnoredDebtors } from '../hooks';

const ExcludedDebtorsInner = () => {
  const { t } = useTranslation();
  const { tp_accounting } = useCompanyConfiguration();
  const { updateIgnoredDebtors, isUpdateIgnoredDebtorsLoading } = useUpdateIgnoredDebtors();

  const [value, setValue] = useState<Array<string>>(tp_accounting.ignored_import_debtors);
  const isDirty = JSON.stringify(value) !== JSON.stringify(tp_accounting.ignored_import_debtors);

  return (
    <Panel
      title={t(tKeys.SETTINGS.INTEGRATIONS.EXCLUDED_DEBTORS.TITLE)}
      footer={
        <Button
          disabled={!isDirty}
          onClick={() => updateIgnoredDebtors(value)}
          loading={isUpdateIgnoredDebtorsLoading}
        >
          {t(tKeys.SAVE)}
        </Button>
      }
    >
      <Typography fz="sm" color="dimmed" mb="md">
        <HTML html={t(tKeys.SETTINGS.INTEGRATIONS.EXCLUDED_DEBTORS.DESCRIPTION)} />
      </Typography>
      <TagsInput
        w={400}
        label={t(tKeys.SETTINGS.INTEGRATIONS.EXCLUDED_DEBTORS.LABEL)}
        allowDuplicates
        acceptValueOnBlur
        value={value}
        onChange={setValue}
      />
    </Panel>
  );
};

export const ExcludedDebtors = () => (
  <ErrorBoundary fallback={<div>Error loading excluded debtors settings.</div>}>
    <ExcludedDebtorsInner />
  </ErrorBoundary>
);
